export default class CreateOrganizationRequest {
  public name: string = ''
  public type: number = 100
  public email: string = ''
  public description: string = ''
  public address1: string = ''
  public address2: string = ''
  public city: string = ''
  public stateOrProvidence: string = ''
  public country: string = ''
  public postalCode: string = ''
  public phoneNumber: string = ''
  public websiteUrl: string = ''
}
